import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import 'antd/dist/reset.css';
import { ToastContainer } from 'react-toastify';





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>      
    {/* <div class=" relative z-10 flex min-h-screen flex-col justify-center overflow-hidden bg-gray-50 bg-gradient-to-tr from-pink-500 bg-[length:100%_calc(100%-100vh+5px)] bg-no-repeat py-6 [--tw-gradient-to:rgb(255_255_255)50%] [--tw-gradient-from:rgb(236_72_153)50%] after:fixed after:inset-0 after:top-1.5 after:-z-10 after:bg-white sm:py-12"> */}
    
    <ToastContainer />
    <App />
    {/* </div> */}
  </Provider>
);

reportWebVitals();
